/* global attachEvent */

// *******************************************************************************
// 1.0 - Open search
// *******************************************************************************

attachEvent('.header-main__search-trigger', 'click', (ev) => {
  ev.preventDefault();
  // Close menu
  document.body.classList.remove('is-open-menu');

  document.body.classList.toggle('is-open-search');
  const serachInput = document.querySelector('.header-search__input-field');
  serachInput.focus();
});

// *******************************************************************************
// 2.0 - Close search
// *******************************************************************************

function closeSearch() {
  document.body.classList.remove('is-open-search');
}

attachEvent('.header-search__close', 'click', (ev) => {
  ev.preventDefault();
  closeSearch();
});

attachEvent('.header-search__overlay', 'click', (ev) => {
  ev.preventDefault();
  closeSearch();
});

document.addEventListener('keyup', (ev) => {
  if (ev.key === 'Escape') {
    ev.preventDefault();
    closeSearch();
  }
});
